module.exports = __webpack_public_path__ + "static/media/publish-videos-images-mobile-es.23904e97.webp";